import React from "react";
import { Fade } from "react-awesome-reveal";
import icon1 from "../../images/icon/check-mark.png";
import hero from "../../images/hero/bugamoney-hero.png";
import icon3 from "../../images/hero/Palystore-qr.png";
import icon4 from "../../images/hero/Appstore-qr.png";
import { NavLink } from "react-router-dom";


const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const Hero6 = () => {
  return (
    <section className="hero hero-style-four pos-rel pt-30">
      <div className="container">
        <div className="hero_wrap pt-10">
          <div className="row align-items-center mt-none-30">
            <div className="col-xl-7 col-lg-6 mt-30">
              <div className="xb-hero">
                <Fade
                  direction="up"
                  triggerOnce={true}
                  duration={1000}
                  delay={9}
                >
                  <div>
                    <h1
                      className="xb-item--title wow fadeInUp color-fade"
                      data-wow-duration="600ms"
                    >
                      Easy. Safe. Free. <br /> Money Transfer
                    </h1>
                  </div>
                </Fade>
                <Fade
                  direction="up"
                  triggerOnce={true}
                  duration={1200}
                  delay={9}
                >
                  <div>
                    <p
                      className="xb-item--content wow fadeInUp"
                      data-wow-delay="150ms"
                      data-wow-duration="600ms"
                    >
                      Remit your money to the pay-out destination in Nigeria in
                      real time. Make a transfer to your family and friends with
                      best exchange rates and <b>ZERO Transaction Fees.</b>
                    </p>
                  </div>
                </Fade>
                <Fade
                  direction="up"
                  triggerOnce={true}
                  duration={1400}
                  delay={9}
                >
                  <div>
                    <ul
                      className="xb-item--item list-unstyled wow fadeInUp"
                      data-wow-delay="300ms"
                      data-wow-duration="600ms"
                    >
                      <li>
                        <span>
                          <img src={icon1} alt="" />
                        </span>{" "}
                        Fast & secure international money transfers
                      </li>
                      <li>
                        <span>
                          <img src={icon1} alt="" />
                        </span>{" "}
                        Competitive exchange rates with ZERO fees
                      </li>
                    </ul>
                  </div>
                </Fade>
                <Fade
                  direction="up"
                  triggerOnce={true}
                  duration={1400}
                  delay={9}
                >
                  <div>
                    <div
                      className="xb-btn mt-30 wow fadeInUp "
                      data-wow-delay="450ms"
                      data-wow-duration="600ms"

                    >
                      <NavLink
                        to="/download-buga-app"
                        
                        rel="noopener noreferrer"
                        className="thm-btn thm-btn--three"
                      >
                        Send Money Now
                      </NavLink>
                      {/* <a
                        href="https://bugamoney.co.uk/app/app-login"
                        onClick={ClickHandler}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="thm-btn thm-btn--three"
                      >
                        Send Money Now
                      </a> */}
                    </div>
                  </div>
                   <div className="xb-item--apps ul_li pt-30 pb-50 d-flex gap-4">
                  <div className="xb-item--app">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.org.bugamoney"
                      onClick={ClickHandler}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={icon3} alt="" style={{width:"120px", height:"160px"}} />
                    </a>
                  </div>
                  <div className="xb-item--app">
                    <a
                      href="https://apps.apple.com/do/app/buga-money-transfer/id6749626385"
                      onClick={ClickHandler}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={icon4} alt="" style={{width:"120px", height:"160px"}} />
                    </a>
                  </div>
                </div>
                </Fade>
              </div>
            </div>

            
            <div className="col-xl-5 col-lg-6 mt-30">
              <div className="hero-right_img pos-rel">
                <div className="hero-right-image">
                  <div>
                    <img
                      className="wow fadeInLeft"
                      data-duration=".7s"
                      src={hero}
                      alt=""
                    />
                  </div>
                </div>
                <div className="xb-img">
                  <div>
                    <div
                      className="img img--one wow fadeInRight"
                      data-duration=".7s"
                      data-delay="1s"
                    >
                      <img className="updown-3" src="" alt="" />
                    </div>
                  </div>
                  <Fade
                    direction="up"
                    triggerOnce={true}
                    duration={1400}
                    delay={9}
                  >
                    <div>
                      {/* <div className="img img--two wow fadeInUp" data-duration=".7s" data-delay="2s"><img src={icon3} alt="" /></div> */}
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero6;
